import React, { Component } from 'react';
import styled from 'styled-components';

const _loaded = {};

const Wrapper = styled.div`
  background: ${props => props.background};
  background-size: cover;
  background-position: center;
  height: ${props => props.height};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

class ImageLoader extends Component {
  state = {
    loaded: _loaded[this.props.src],
  };

  static defaultProps = {
    className: '',
    loadingClassName: 'img-loading',
    loadedClassName: 'img-loaded',
  };

  onLoad = () => {
    _loaded[this.props.src] = true;
    this.setState(() => ({ loaded: true }));
  };

  render() {
    let { className, src, id } = this.props;

    className = `${className} ${
      this.state.loaded ? 'img-loaded' : 'img-loading'
    }`;

    return (
      <Wrapper
        background={src && `url('${src}')`}
        onClick={this.props.onClick}
        className={className}
        onLoad={this.onLoad}
        height={
          id === 'profession'
            ? '595px'
            : id === 'post'
            ? '595px'
            : id === 'course'
            ? '595px'
            : id === 'findce'
            ? '100vh'
            : '800px'
        }
      >
        {this.props.children}
      </Wrapper>
    );
  }
}

export default ImageLoader;



// WEBPACK FOOTER //
// ./src/components/shared/ImageLoader.jsx